<template>
  <b-container class="paragraph-with-visual">
    <header>
      <div class="headline">
        <h1>{{slice.primary.headline}}</h1>
        <Swoosh :uid="item.uid" animate />
      </div>
      <div v-if="hasMainDescription" class="main-description">
        <prismic-rich-text :field="slice.primary.description" />
      </div>
    </header>
    <section class="items">
      <b-row class="item align-items-center" v-for="item in slice.items" :key="item.id" :to="item.link.url">
        <b-col v-if="hasImageLeft(item)" class="d-flex justify-content-center">
          <b-img
              :alt="item.optional_image_left.alt"
              :src="item.optional_image_left.url"
              class="visual"
          />
        </b-col>
        <b-col :cols="(() => {
            if (hasImageLeft(item) && hasImageRight(item)) return 6;
            if (hasImageLeft(item) || hasImageRight(item)) return 8;
            return 12;
          })()" class="text d-flex flex-column">
          <div v-if="item.label != null">
            <h3><b>{{item.label}}</b></h3>
            <Swoosh class="smallSwoosh" :uid="item.uid" animate />
            <prismic-rich-text :field="item.bodyText" />
          </div>
          <template v-if="item.link.url">
            <b-button
                variant="primary"
                class="outline"
                :aria-label="item.link.label"
                :href="item.link.url"
            >
              {{item.link.label || 'Link'}}
            </b-button>
          </template>
          <template v-else-if="item.link.uid">
            <b-button
                variant="primary"
                class="outline"
                :aria-label="item.link.label"
                :to="'/'+language+'/'+item.link.uid"
            >
              {{item.link.label || 'Link'}}
            </b-button>
          </template>
        </b-col>
        <b-col v-if="hasImageRight(item)" class="d-flex justify-content-center">
          <b-img
              :alt="item.optional_image_right.alt"
              :src="item.optional_image_right.url"
              class="visual"
          />
        </b-col>
      </b-row>
    </section>
  </b-container>
</template>

<script>
// import Swoosh from "@/components/ui/Swoosh.vue";
import Swoosh from "./Swoosh.vue";

export default {
  name: "SliceParagraphWithVisual",
  props:['item', 'slice'],
  components: {Swoosh},
  methods: {
    hasImageLeft(item){
      const hasLeft = (item.optional_image_left && item.optional_image_left.url);
      console.log(hasLeft);
      return hasLeft;
    },
    hasImageRight(item){
      const hasRight = (item.optional_image_right && item.optional_image_right.url);
      console.log(hasRight);
      return hasRight;
    },
  },
  computed: {
    hasMainDescription(){
      console.log("slice:", this.slice)
      return this.slice.primary.description && this.slice.primary.description.length > 0 && this.slice.primary.description[ 0 ].text != "" ? true : false
    },
  }
}
</script>

<style scoped lang="scss">
.headline {
  .desktop & h1 {
    max-width: 80%;
  }

  .mobile & {
    h1 {
      line-height: 100%;
    }

    & .swoosh {
      width: 100%;
    }
  }

  .tablet & .swoosh {
    width: 70%;
  }

  .desktop & .swoosh {
    width: 50%;
  }
}
.items {
  .item {
    margin-bottom: 1rem;
    min-height: 0vw;

    .visual {
      aspect-ratio: 1/1;
      width: 100%;
      max-width: 100%;
      object-fit: cover;
      @include swoosh;
    }

    .text {
      text-align: start;
      padding: 1rem;

      h3 {
        text-align: start;
      }

      .outline {
        margin-top: 1rem;
        align-self: center;
      }
    }
  }
}
.smallSwoosh{
  max-width: 60%;
  margin-bottom: 1rem;
}

</style>